import React from 'react';
import { FormikValues } from 'formik';
import { FormItem, SingleFormItemProps } from '../FormItem';
import { RadioInput, RadioInputProps } from './RadioInput';

interface Props<T extends FormikValues> extends RadioInputProps<T> {
  itemProps?: SingleFormItemProps<T>;
  label?: React.ReactNode;
}

/**
 * Form Item per input di tipo Radio.
 */
export function RadioInputItem<T extends FormikValues>(props: Props<T>) {
  const { name, label, itemProps, ...otherProps } = props;

  return (
    <FormItem {...itemProps} name={name} label={label}>
      <RadioInput {...otherProps} name={name} />
    </FormItem>
  );
}
